/**
 * File: AslMcqController.js
 * Project: educore
 * Created Date: 2018-12-07
 * Author: Arul Mozhi J
 * Copyright (c) 2018 Cordova Cloud Solutions Pvt Ltd
 * ------------------------------------
 */
class AslMcqController {
    // @ngInject
    constructor($scope, $rootScope, localStorageService, $state, $timeout,CONSTANTS,CQuesConst,uploadService) {
        
    var MQ = MathQuill.getInterface(2);
    let UPLOAD_URL = CONSTANTS.SERVER_UPLOAD
    let userId = localStorageService.get("user_id")
    let USER_PATH = userId + "/asl/"
    let schoolId = localStorageService.get("school_id")
    let ASL_ANS_TYPE=CQuesConst.ASL_ANS_TYPE
    let PREVIEW_URL = CONSTANTS.FILE_UPLOAD_URL
    let QUESTION_IMG_SUPPORT_FORMAT = CQuesConst.QUESTION_IMG_SUPPORT_FORMAT
    let GET_ALL_PASSAGES = CQuesConst.API_GET_ALL_PASSAGES
    let GET_PASSAGE = CQuesConst.API_GET_PASSAGE
    let SAVE_URL = CQuesConst.API_CREATE_DRAW
        $scope.mcq = {}

        $scope.errors = {};

        $scope.mcq.options = [];

        $scope.mcq.question = "";

        $scope.mcq.questionImg = "";

        $scope.mcq.isLatex = false;

        $scope.index;
        //On init function
        this.$onInit = () => {
            $rootScope.isLoggedIn = localStorageService.get("is_login") ? localStorageService.get("is_login") : false
            $rootScope.title = "Archives"
            if (!$rootScope.isLoggedIn) {
                $state.go("login", {}, {
                    reload: true
                })
            }
            $scope.index = this.index
            $scope.id = "math-field" + $scope.index;
            if ($scope.$parent.editQuestions[$scope.index]) {
                let question = $scope.$parent.editQuestions[$scope.index]
                if (question) {
                    $scope.mcq.question = question.qn_desc;
                    $scope.mcq.questionImg = question.questionImg;
                    $scope.mcq.isLatex = question.isLatex;
                    if (question.choice && question.choice.length > 0) {
                        $scope.mcq.options = [];
                        _.each(question.choice, function (ch) {
                            var colorIndex = calIndex($scope.mcq.options.length, 4);
                            $scope.mcq.options.push({
                                'caption': ch.tag,
                                'color': self.optionColors[colorIndex],
                                'value': ch.desc,
                                'hint': ch.hint,
                                'correct': ch.correct,
                                'optImage': ch.optImage
                            })
                        })
                    }
                }
            }
        }
        //On destroy function
        this.$onDestroy = () => {
        }
        this.alphabets = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z']

        this.optionColors = ["#f3c301", "#2ab4bf", "#e74f5b", "#1bbc9d"];

        for (var i = 0; i < 4; i++) {
            let option = {
                caption: this.alphabets[i],
                color: this.optionColors[i]
            }
            $scope.mcq.options.push(option)
        }

        var calIndex = function (index, length) {
            if (index >= length) {
                if ((index - length) >= length)
                    return calIndex(index - length, length)
                else
                    return index - length;
            } else
                return index;
        }

        //Image upload for question
        $scope.mcq.uploadImg = function (file, opt) {
            let supportedFrmts = QUESTION_IMG_SUPPORT_FORMAT
            _.each(file, function (fileObj) {
                let extValue = fileObj.name.split('.').pop().toLowerCase();
                if (_.contains(supportedFrmts, extValue)) {
                    uploadService.uploadCheckService(fileObj, UPLOAD_URL, USER_PATH, function (result) {
                        if (result.url) {
                            opt.questionImg = result.url
                        }
                    })
                } else {
                    toastr.error("Please select the supported format jpg, jpeg, png")
                    fileObj = {}
                }
            })
        }

        $scope.mcq.removeQuestionImg = function (index) {
            $scope.mcq.questionImg = undefined;
        }

        $scope.paste = function (e) {
            e.preventDefault();
            return false
        }

        //Image upload for option
        $scope.mcq.optionImgUpload = function (file, opt) {
            let supportedFrmts = QUESTION_IMG_SUPPORT_FORMAT
            _.each(file, function (fileObj) {
                let extValue = fileObj.name.split('.').pop().toLowerCase();
                if (_.contains(supportedFrmts, extValue)) {
                    uploadService.uploadCheckService(fileObj, UPLOAD_URL, USER_PATH, function (result) {
                        if (result.url) {
                            _.each($scope.mcq.options, function (key, val) {
                                if ($scope.mcq.options[val].caption === opt.caption) {
                                    var resultOpt = $scope.mcq.options[val];
                                    resultOpt['optImage'] = result.url
                                }
                            })
                        }
                    })
                } else {
                    toastr.error("Please select the supported format jpg, jpeg, png")
                    fileObj = {}
                }
            })
        }

        $scope.mcq.removeImage = function (index) {
            $scope.mcq.options[index].optImage = undefined;
        }

        $scope.mcq.addOption = function () {
            var alphaIndex = calIndex($scope.mcq.options.length, 26);
            var colorIndex = calIndex($scope.mcq.options.length, 4);
            var option = {
                'caption': this.alphabets[alphaIndex],
                'color': this.optionColors[colorIndex]
            }
            $scope.mcq.options.push(option)
        }

        $scope.mcq.removeOption = function (index) {
            if ($scope.mcq.options.length == 2) {
                return false;
            } else {
                var tempOptions = [];
                angular.copy($scope.mcq.options, tempOptions)
                for (var i = 0; i < $scope.mcq.options.length; i++) {
                    if (i > index) {
                        $scope.mcq.options[i].caption = tempOptions[i - 1].caption;
                        $scope.mcq.options[i].color = tempOptions[i - 1].color;
                    }
                }
                $scope.mcq.options.splice(index, 1)
            }
        }



        //Question desc with latex
        $timeout(() => {
            var mathFieldSpan = document.getElementById('math-field' + $scope.index);
            mathFieldSpan.className = 'ng-pristine ng-valid md-input ng-empty ng-touched'
            var MQ = MathQuill.getInterface(2);
            if ($scope.mcq.question) {
                mathFieldSpan.textContent = $scope.mcq.question
            }
            var mathField = MQ.MathField(mathFieldSpan, {
                spaceBehavesLikeTab: false,
                restrictMismatchedBrackets: true,
                handlers: {
                    edit: function () {
                        $scope.mcq.question = mathField.latex()
                    }
                }
            });
        }, 10)



        //Invokes after the option elements loaded
        $scope.mcq.optionsLoaded = function (option) {
            var optionFieldSpan = document.getElementsByClassName('option-field');
            _.each(optionFieldSpan, function (spanElement) {
                spanElement.className = 'ng-pristine ng-valid md-input ng-empty ng-touched'
                if (option.value) {
                    spanElement.textContent = option.value
                }
                var optionField = MQ.MathField(spanElement, {
                    spaceBehavesLikeTab: false,
                    restrictMismatchedBrackets: true,
                    handlers: {
                        edit: function () {
                            option.value = optionField.latex()
                        }
                    }
                });
            })
        }

        //Invokes after the hint elements loaded
        $scope.mcq.hintsLoaded = function (option) {
            var hintFieldSpan = document.getElementsByClassName('hint-field');
            _.each(hintFieldSpan, function (spanElement) {
                spanElement.className = 'ng-pristine ng-valid md-input ng-empty ng-touched'
                if (option.hint) {
                    spanElement.textContent = option.hint
                }
                var hintField = MQ.MathField(spanElement, {
                    spaceBehavesLikeTab: false,
                    restrictMismatchedBrackets: true,
                    handlers: {
                        edit: function () {
                            option.hint = hintField.latex()
                        }
                    }
                });
            })
        }

        /*
         * Function to add to list
         *
         * @return : null
         */
        $scope.addToList = () => {
            $scope.errors = {}
            let errCount = 0;

            let answerArr = [];

            let duplicateOptCnt = 0;

            let correctAnswerCount = 0;

            let choicesData = []

            _.each($scope.mcq.options, function (optionObj, index) {
                let option = {
                    "tag": optionObj.caption,
                    "desc": optionObj.value,
                    "correct": optionObj.correct,
                    "optImage": optionObj.optImage,
                    "hintImage": ""
                }
                if (optionObj.correct) {
                    option["hint"] = optionObj.hint
                    option['curr'] = 1
                } else {
                    option["correct"] = false
                    option["hint"] = optionObj.hint
                    option['curr'] = 0
                }
                choicesData.push(option)
            })

            let objToValidate = {
                "qn_desc": $scope.mcq.question,
                "choice": choicesData,
            }

            //Validation  
            if (objToValidate.qn_desc == null || objToValidate.qn_desc == undefined || objToValidate.qn_desc == "") {
                $scope.errors.qn_desc = "Question is required";
                errCount++;
            } else if (objToValidate.qn_desc.length > 500) {
                $scope.errors.qn_desc = "Question does not exceed 500 characters";
                errCount++;
            }
            if (objToValidate.choice) {
                _.each(objToValidate.choice, function (answer, index) {
                    if ($scope.isPractice) {
                        if (answer.hint == null || answer.hint == undefined || answer.hint == "") {
                            $scope.errors["option." + index + ".hint"] = "Hint is required"
                            errCount++;
                        }
                    }
                    if (answer.hint && answer.hint.length > 500) {
                        $scope.errors["option." + index + ".hint"] = "Hint does not exceed 500 characters"
                        errCount++;
                    }
                    if (answer.desc == null || answer.desc == undefined || answer.desc == "") {
                        $scope.errors["option." + index + ".desc"] = "Answer is required"
                        errCount++;
                    } else if (answer.desc.length > 500) {
                        $scope.errors["option." + index + ".desc"] = "Answer does not exceed 500 characters"
                        errCount++;
                    }
                    if (answer.correct)
                        correctAnswerCount++
                    if (answer.desc) {
                        if (answerArr.indexOf(answer.desc) === -1) {
                            answerArr.push(answer.desc)
                        } else {
                            duplicateOptCnt++
                        }
                    }
                })
                if (correctAnswerCount === 0) {
                    $scope.errors["correctAnswer"] = "Select a correct answer";
                    errCount++;
                }
                if (objToValidate.choice.length === correctAnswerCount) {
                    $scope.errors["correctAnswer"] = "Select a correct answer. You cannot select all choices as correct";
                    errCount++;
                }
                if (duplicateOptCnt > 0) {
                    $scope.errors['duplicateAns'] = "options are repeated."
                    errCount++;
                }
            }
            if (errCount == 0) {
                let pattern;
                if (correctAnswerCount > 1)
                    pattern = "multiple"
                else
                    pattern = "single"
                let obj = {
                    type: ASL_ANS_TYPE.MCQ,
                    "qn_desc": $scope.mcq.question,
                    "isLatex": $scope.mcq.isLatex,
                    "choice": choicesData,
                    "pattern": pattern,
                    questionImg: $scope.mcq.questionImg
                }
                $scope.mcq.question = ''
                _.each($scope.mcq.options, function (option_val, option_key) {
                    $scope.mcq.options[option_key].value = ''
                    $scope.mcq.options[option_key].hint = ''
                    if ($scope.mcq.options[option_key].correct) {
                        $scope.mcq.options[option_key].correct = ''
                    }
                })
                $scope.$parent.addToList(obj, $scope.index)
            }
        }

    }
}

export default AslMcqController;


// WEBPACK FOOTER //
// ./src/app/createQuestion/controllers/aslMcqController.js